import React,{Component,PropTypes} from 'react';
import connect from "react-redux/es/connect/connect";
import * as wActs from "../actions/website-actions";
import * as sActs from '../actions/server-actions';
import * as wConst from "../consts/website-consts";



class EPomBanner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      data: {},
      sectionid: this.props.sectionid
    }
  }

  componentDidMount() {
    if(typeof window === "undefined") { return; }
    let tStr = this.props.HtmlSections[this.state.sectionid];
    if(wActs.isNullOrUndefined(tStr)) {
      return;
    }
    if(tStr.indexOf("adbutler")>-1) {
      this.setState({loaded: true, data: {code: tStr}});
      return
    }
    let tTag = this.createElementFromHTML(tStr);
    let tKey = tTag.getAttribute("data-key");
    let tChn = tTag.getAttribute("data-channel");
    if(!this.state.loaded) { this.getBanner(tKey,tChn); }
  }

  createElementFromHTML(htmlString) {
    let div = document.createElement('div');
    div.innerHTML = htmlString.trim();
    return div.firstChild;
  }

  getBanner(key,channel) {
    let self = this;
    let url = `https://aj1573.online/ads-api?key=${key}&requestUrl=${encodeURIComponent(wActs.GetReferer())}&format=json&ch=${channel}`;
    //console.log(url);
    fetch(url)
      .then(resp => resp.json())
      .then(function (data) {
        if(data.success) {
          self.setState({loaded: true, data: data});
        }
      })
      .catch(function (ex) {
          console.log(ex);
      });
  }

  render() {
    if(!this.props.WebPage.Loaded) {
      return null;
    }
    if(typeof window === "undefined") {
      return null;
    }
    if(!this.state.loaded) {
      return null;
    }
    return (
      <div dangerouslySetInnerHTML={{__html: this.state.data.code}}></div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    WebPage: state.Website,
    HtmlSections: state.Website.Settings.HtmlSections
  };
};

export default connect(mapStateToProps)(EPomBanner);
